/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ApiError, hasExceptionId } from '@common/tech-shared';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { ButtonComponent, IconComponent } from '@ods/system';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'ozgcloud-internal-server-error-dialog',
  templateUrl: './internal-server-error-dialog.component.html',
  styleUrls: ['./internal-server-error-dialog.component.scss'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, ButtonComponent, IconComponent],
})
export class InternalServerErrorDialogComponent {
  public data: ApiError = inject<ApiError>(MAT_DIALOG_DATA);
  public authService = inject(OAuthService);

  showId(): boolean {
    return hasExceptionId(this.data);
  }
}
